function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("title", null, "HD_Icons_Ivonne_Final"), /*#__PURE__*/React.createElement("path", {
  d: "M219.9 42.5H241V14.2H42.5v28.3H64v69.4l29.3 29.6L64 171.6v69.3H42.5v28.3h198.4v-28.3h-21.1v-69.3l-29.3-30.2 29.3-29.6V42.5zm-69.2 98.8l40.7 41.9V241H92.5v-57.8l40.7-41.9-40.7-41.1V42.5h98.9v57.7l-40.7 41.1z"
}))));